import PropTypes from 'prop-types'
import { Container, Section } from 'chaoskit/src/components'

import { CaseStudyTeasers } from '~components/case-studies/UI'

const IndustryCaseStudies = ({ data }) => {
  // Emulates data structure normal `<CaseStudyTeasers />` expects
  const caseStudies = data.reduce(
    (acc, cur) => acc.concat({ node: cur.title }),
    []
  )

  return (
    <Section css={{ paddingBottom: '0 !important' }}>
      <Container>
        <CaseStudyTeasers caseStudies={caseStudies} />
      </Container>
    </Section>
  )
}

IndustryCaseStudies.propTypes = {
  data: PropTypes.array.isRequired,
}

export default IndustryCaseStudies
